import React, { useEffect, useState } from 'react';
import { Globals as OldGlobals } from '../../global/Globals';
import './RegisterFooter.css';
import { useLocation, useNavigate} from 'react-router-dom';
import { useLanguage } from '../../context/Languagecontext';
const RegisterFooter = ({ onCancelRegister, onSubmit, isButtonEnabled, tabIndex1=0, tabIndex2=0, isSysAdmin=false, approveProposal, rejectProposal }) => {
    const { Globals } = useLanguage();
    const location = useLocation();
    const navigate = useNavigate();
    const isIndividualEditPage = location.pathname.includes('edit-company');
    const isProductionEditPage = location.pathname.includes('edit-producer')
    const [btnClassName, setBtnClassName] = useState('disabled-btn');
    
    useEffect(() => {
        if (isButtonEnabled) {
            setBtnClassName("register-btn-active")
        }
        else{
            setBtnClassName("disabled-btn");
        }
    },[isButtonEnabled]);
    const cancelRegistration = () => {
        if (onCancelRegister) {
            onCancelRegister();
        }
    }
    const handleClick = () => {
          cancelRegistration();
      };
    
    const registerUser = () => {
            onSubmit();
          }
    
    //This function will approve the company registration proposal
    const approve=()=>{approveProposal();}

    //This function will reject the company registration proposal
    const reject=()=>{rejectProposal();}
        
    return (
        <div id="register-footer" className="register-footer">
            <div className="register-footer-btn-frame">
            <div className="reg-footer-btn-group">
                {isSysAdmin===false&&<span  tabIndex={tabIndex1} className="reg-footer-cancel-reg-btn" onClick={handleClick}>{Globals.SIGNUP.CANCEL}</span>}
                {isSysAdmin===false&&<button tabIndex={tabIndex2} onClick={registerUser} id="register-submit-btn" className={btnClassName} disabled={!isButtonEnabled}>{(isIndividualEditPage || isProductionEditPage) ?Globals.LOGIN.UPDATE:Globals.LOGIN.REGISTER}</button>}
                {isSysAdmin && <span  tabIndex={tabIndex1} className="reg-footer-cancel-reg-btn" onClick={handleClick}>{Globals.SYS_ADMIN.CTA.CLOSE}</span>}
                
                {/* The below code is commented as the requirement US 1012849 needs the changes temporirly */}

                {/*{isSysAdmin&&<button tabIndex={tabIndex2} onClick={reject} id="reject-comp-reg-proposal" className="reject-comp-reg-proposal">{Globals.SYS_ADMIN.CTA.REJECT}</button>}
                {isSysAdmin&&<button tabIndex={tabIndex2} onClick={approve} id="approve-comp-reg-proposal" className="approve-comp-reg-proposal">{Globals.SYS_ADMIN.CTA.APPROVE}</button>}*/}
            </div>
            </div>
        </div>
    );
}
export default RegisterFooter;